'use client';

import { useEffect, useRef, ReactNode } from 'react';
import { getContainer } from '@framework/di/getContainer';
import TrackingConsent from './TrackingConsent';

interface IProps {
  initialized: boolean;
  session: { ssid?: string } | null;
  children: ReactNode;
}

/**
 * If user is authenticated via session, ensures consent cookies exist and notifies trackers.
 * Place inside SessionContext so that `initialized` and `session` are available.
 */
function TrackingConsentGate({ initialized, session, children }: IProps) {
  const activatedRef = useRef(false);
  const trackingConsent = getContainer().get(TrackingConsent);

  useEffect(() => {
    if (activatedRef.current || !initialized) return;
    if (session?.ssid) {
      activatedRef.current = true;
      trackingConsent.ensureConsentForAuthenticatedUser();
    }
  }, [initialized, session]);

  return <>{ children }</>;
}

export default TrackingConsentGate;
